import React from "react";
import { getDateWithMonthName, getTime } from "../../ConvertDate";
import T from "i18n-react";
import { ReactComponent as ClockSVG } from "../../../imges/clock_new.svg";
import { ReactComponent as CalendarSVG } from "../../../imges/calendar_new.svg";
import { ReactComponent as FoodPlateSVG } from "../../../imges/FoodPlate.svg";
import { ReactComponent as BicycleSVG } from "../../../imges/Bicycle.svg";
import { ReactComponent as BagSVG } from "../../../imges/Bag_new.svg";
import OrderStatus from "../OrderStatus";
import Styles from "./orderHistoryView.module.scss";
import { IOrderHistoryViewProps } from "./types.d";
import { priceToPounds } from "../../../utils/pricingCalculator";
import { convertToUTCTime } from "../../../yoello-lib/modules/utils/TimeConversion";
function OrderHistoryView({ venueLogo, info }: IOrderHistoryViewProps) {
  const renderDateAndTime = () => (
    <div className={Styles.dateAndTime}>
      <div>
        <CalendarSVG />
        <p>{getDateWithMonthName(info.placed_order_created_on)}</p>
      </div>
      <div>
        <ClockSVG />
        <p>{getTime(info.placed_order_created_on)}</p>
      </div>
    </div>
  );
  const renderOrderType = () => {
    let Icon: React.ReactNode = null;
    let orderType: string = "";
    let value: string = "";
    let deliveryAddress: string | null = null;
    if (info.placed_order_delivery_table !== null) {
      Icon = <FoodPlateSVG fill={"#FFDD02"} />;
      orderType = T.translate("Venue.TableService") as string;
      value = info.placed_order_table_area
        ? `${info.placed_order_table_area},Table ${info.placed_order_delivery_table}`
        : `Table ${info.placed_order_delivery_table}`;
    } else if (info.placed_order_delivery_address !== null) {
      Icon = <BicycleSVG fill={"#FFDD02"} />;
      orderType = T.translate("Venue.Delivery") as string;
      value = convertToUTCTime(info.placed_order_takeaway_timeslot);
      // convertToJalali(info.placed_order_takeaway_timeslot, false, true)
      deliveryAddress = `${info.placed_order_delivery_address.address} 
      ${info.placed_order_delivery_address.city}
      ${info.placed_order_delivery_address.postcode}, 
      ${info.placed_order_delivery_address.full_name}`;
    } else if (
      info.placed_order_takeaway_timeslot &&
      !info.placed_order_delivery_address
    ) {
      Icon = <BagSVG fill={"#FFDD02"} />;
      orderType = T.translate("Venue.Collection") as string;
      value = convertToUTCTime(info.placed_order_takeaway_timeslot);
    }
    return (
      <div className={Styles.orderType}>
        <div>
          <div>
            {Icon}
            <p>{orderType}</p>
          </div>
          <div>
            <p>{value}</p>
          </div>
        </div>
        {deliveryAddress && (
          <div className={Styles.deliveryDetails}>
            <p>{deliveryAddress}</p>
          </div>
        )}
        <div>
          {venueLogo && <img src={venueLogo} alt={info.venue_name} />}
          <div>
            <p>{info.venue_name}</p>
            <p>{info.venue_location_name}</p>
          </div>
        </div>
      </div>
    );
  };
  const formatToOrderCurrency = (price) => {
    return `${info.currency_symbol}${priceToPounds(price)}`;
  };
  return (
    <div
      data-component-name="OrderDetailsContainerDiv"
      className={Styles.orderHistoryViewContainer}
    >
      <div className={Styles.orderDetails}>
        <div className={Styles.orderRefAndStatus}>
          <div>
            <T.p text={{ key: `OrderHistory.Orderref` }} />
            <p data-component-name="OrderDetailsOrderID" className="Text1">
              {info.placed_order_ref}
            </p>
          </div>
          <div>
            {info.placed_order_status && (
              <OrderStatus status={info.placed_order_status} />
            )}
          </div>
        </div>
        <>{renderDateAndTime()}</>
        <>{renderOrderType()}</>
      </div>
      <div className={Styles.paymentDetails}>
        <div className={Styles.totalPrice}>
          <T.p text={{ key: `ShopCart.Total` }} />
          <p>{formatToOrderCurrency(info.placed_order_total)}</p>
        </div>
        <div className={Styles.priceDetails}>
          <T.p text={{ key: `ShopCart.Subtotal` }} />
          <p>{formatToOrderCurrency(info.placed_order_gross)}</p>
        </div>
        <div className={Styles.priceDetails}>
          <T.p text={{ key: `ShopCart.Tip` }} />
          <p>{formatToOrderCurrency(info.placed_order_gratuity)}</p>
        </div>
        {info.placed_order_processing_charge !== 0 && (
          <div className={Styles.priceDetails}>
            <T.p text={{ key: `ShopCart.ServiceCharge` }} />
            <p>{formatToOrderCurrency(info.placed_order_processing_charge)}</p>
          </div>
        )}
        {info.placed_order_service_charge !== 0 && (
          <div className={Styles.priceDetails}>
            <T.p text={{ key: `ShopCart.DeliveryCharge` }} />
            <p>{formatToOrderCurrency(info.placed_order_service_charge)}</p>
          </div>
        )}
        {info.placed_order_total_vat_amount !== 0 && (
          <div className={Styles.priceDetails}>
            <T.p text={{ key: `OrderHistory.TotalVAT` }} />
            <p>{formatToOrderCurrency(info.placed_order_total_vat_amount)}</p>
          </div>
        )}
        {info.payment_card_type && (
          <div className={Styles.paymentCardDetails}>
            <p>{T.translate("Payment.PaymentOption")}</p>
            <p>
              {info.payment_card_type}
              {info.payment_card_number
                ? info.payment_card_number.substr(
                    info.payment_card_number.length - 4
                  )
                : ""}
            </p>
          </div>
        )}
      </div>
      <div
        style={{
          paddingBottom: "2rem",
        }}
      >
        {info?.placed_order_items?.map((item, i) => (
          <PlacedOrderItem
            key={i}
            item={item}
            formatToOrderCurrency={formatToOrderCurrency}
            // TotalPrice={formatToOrderCurrency(item.main_and_extras_total_price)}
          />
        ))}
      </div>
    </div>
  );
}

const PlacedOrderItem = (props) => {
  const item = props.item;

  return (
    <div className={Styles.productInfo}>
      <div>
        <div className={Styles.productDetails}>
          <p className={Styles.productName}>
            {item.main_in_order_item_name_public}
          </p>
          <p className={Styles.productPricingOption}>
            {item.main_in_order_item_pricing_option_name}
          </p>
          <p className={Styles.productPrice}>
            {item.main_in_order_item_gross
              ? props.formatToOrderCurrency(
                  item.main_in_order_item_gross /
                    item.main_in_order_item_quantity
                )
              : ""}
          </p>
        </div>
        <div>
          <p>{item.main_in_order_item_quantity}x</p>
        </div>
      </div>
      <div>
        {item?.main_in_order_item_extras?.map((extra, i) => {
          return (
            <div key={i} className="Flex JustBetween">
              <p className={Styles.extraItemName}>
                <span className={Styles.listItemDot} />{" "}
                {extra.extra_in_order_item_name_public}{" "}
                {extra.extra_in_order_item_pricing_option_name
                  ? `(${extra.extra_in_order_item_pricing_option_name})`
                  : ""}
              </p>
              <p className={Styles.extraItemPrice}>
                {extra.extra_in_order_item_quantity > 1
                  ? `${extra.extra_in_order_item_quantity}x`
                  : ""}{" "}
                {props.formatToOrderCurrency(extra.extra_in_order_item_gross)}
              </p>
            </div>
          );
        })}

        {item?.main_in_order_item_preferences?.map((preference, i) => {
          return (
            <p key={`preference${i}`}>
              <span className={Styles.listItemDot} /> {preference}
            </p>
          );
        })}
      </div>
    </div>
  );
};

export default OrderHistoryView;
